export interface SignupInterface {
  email: string;
  password: string;
  confirm_password: string;
  redirectUrl: string;
}